export { default as getCurrentOptionRoute } from './routing/getCurrentOptionRoute';
export { initializeOptionRoutes } from './routing/optionRoutes';
